module.exports = __webpack_public_path__ + "static/media/02b.8e875026.png";